import { render, staticRenderFns } from "./channelClues.vue?vue&type=template&id=0976fe82&scoped=true&lang=html&"
import script from "./channelClues.vue?vue&type=script&lang=js&"
export * from "./channelClues.vue?vue&type=script&lang=js&"
import style0 from "./channelClues.vue?vue&type=style&index=0&id=0976fe82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0976fe82",
  null
  
)

component.options.__file = "channelClues.vue"
export default component.exports